module.exports = __webpack_public_path__ + "static/img/5.c6fe121c.jpg";